// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"LoadingFullWindow_backdrop__-Bk29","fade":"LoadingFullWindow_fade__1mDOr","body":"LoadingFullWindow_body__16zOf","label":"LoadingFullWindow_label__RCnar"};